import React, { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';
import { Section, Text } from '@tradingblock/components';
import { PageTitle } from '../components';
import { ApplicationLoader } from '../components/application';
import { FieldValue } from '../components/values';
import { UnsupportedFeatureType } from '../types';
import { useData } from '../state/selectors';
import { Country } from '@tradingblock/types';

const UnsupportedFeaturePage: React.FC<RouteComponentProps<{ type: UnsupportedFeatureType; country: Country }>> = ({
  match,
}) => {
  const { type, country } = match.params;
  const application = useData(d => d.data.application);

  const textData = useMemo(() => {
    if (type === UnsupportedFeatureType.Country) {
      return { country: <FieldValue value={country as Country} textPrefix="defaults.country" /> };
    }
    if (type === UnsupportedFeatureType.IrsWithholding) {
      return {
        irsWithholding: application && (
          <FieldValue
            value={application.primaryAccountHolder.disclosures.irsWithholding}
            textPrefix="defaults.irsWithholding"
          />
        ),
      };
    }
    return undefined;
  }, [type, application]);

  return (
    <ApplicationLoader allowAnonymous={type === UnsupportedFeatureType.Country}>
      <PageTitle page="unsupported" titleKey={type} />
      <Section>
        <div className="step-title">
          <h1>
            <Text id={type} page="unsupported" />
          </h1>
        </div>
      </Section>
      <Section>
        <h2 className="fields-title">
          <Text id={type} page="unsupported" />
        </h2>
        <p>
          <Text id={type} page="unsupported" textKey="description" data={textData} />
        </p>
      </Section>
      <Section>
        {/* Go Back Button */}
        <div className="step-buttons">
          <button className="btn btn-primary" onClick={() => window.history.back()}>
            <Text id="go-back" page="unsupported" />
          </button>
        </div>
      </Section>
    </ApplicationLoader>
  );
};

export default UnsupportedFeaturePage;
